import React from "react"

const BlueSpan = (props) => (
  <span className={`${props.className} font-bold text-blue-500`}>
  {props.children}
  </span>
)

export default BlueSpan